import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { isLogin } from '../../../helpers/authentication';
import { mainPage } from '../../../router/routes';

const PublicRoute = () => (isLogin() ? <Navigate to={mainPage} /> : <Outlet />);

export default PublicRoute;
